import dayjs, { Dayjs } from 'dayjs';
import { produce } from 'immer';
import { create } from 'zustand';

interface BaseErrorInfo {
  fileName: string;
  time: Dayjs;
}

export type MessageBase = {
  message: string;
  canOptimize: boolean;
};

interface DetailErrorInfo extends BaseErrorInfo {
  desc: MessageBase[];
  file?: Blob;
}

export interface InfoList {
  sizeLimitList: BaseErrorInfo[];
  formatList: BaseErrorInfo[];
  errorList: DetailErrorInfo[];
  warningList: DetailErrorInfo[];
}

interface InfoState {
  info: InfoList;
  addInfo: (
    type: 'size' | 'error' | 'format' | 'warn',
    fileName: string,
    desc?: MessageBase[],
    blob?: Blob,
  ) => void;
  clearInfo: () => void;
  hasAnyError: () => boolean;
}

// 用于直接导入模型到场景中时保存模型检测信息
export const useImportModelInfoStore = create<InfoState>((set, get) => ({
  info: {
    sizeLimitList: [],
    formatList: [],
    errorList: [],
    warningList: [],
  },
  addInfo: (type, fileName, desc, blob) => {
    set(
      produce<InfoState>((draft) => {
        switch (type) {
          case 'size': {
            draft.info.sizeLimitList.push({
              fileName,
              time: dayjs(),
            });
            break;
          }
          case 'format': {
            draft.info.formatList.push({
              fileName,
              time: dayjs(),
            });
            break;
          }
          case 'error': {
            draft.info.errorList.push({
              fileName,
              desc: desc || [],
              file: blob,
              time: dayjs(),
            });
            break;
          }
          case 'warn': {
            draft.info.warningList.push({
              fileName,
              desc: desc || [],
              file: blob,
              time: dayjs(),
            });
            break;
          }
          default:
            break;
        }
      }),
    );
  },

  clearInfo: () => {
    set({
      info: {
        sizeLimitList: [],
        formatList: [],
        errorList: [],
        warningList: [],
      },
    });
    // set({
    //   info: {
    //     sizeLimitList: [
    //       { fileName: 'aaa', time: dayjs() },
    //       { fileName: 'bbb', time: dayjs() },
    //     ],
    //     formatList: [
    //       { fileName: 'aaa', time: dayjs() },
    //       { fileName: 'bbb', time: dayjs() },
    //     ],
    //     errorList: [
    //       { fileName: 'aaa', time: dayjs(), desc: ['err1', 'err2'] },
    //       { fileName: 'bbb', time: dayjs(), desc: ['err1', 'err2'] },
    //     ],
    //     warningList: [
    //       { fileName: 'ccc', time: dayjs(), desc: ['err1', 'err2'] },
    //       { fileName: 'ddd', time: dayjs(), desc: ['err1', 'err2'] },
    //     ],
    //   },
    // });
  },

  hasAnyError: () => {
    const list = get().info;
    const a = list.errorList.length || list.formatList.length || list.sizeLimitList.length;
    return a > 0;
  },
}));

// 用于替换模型时保存模型检测信息
export const useReplaceModelInfoStore = create<InfoState>((set, get) => ({
  info: {
    sizeLimitList: [],
    formatList: [],
    errorList: [],
    warningList: [],
  },
  addInfo: (type, fileName, desc, file) => {
    set(
      produce<InfoState>((draft) => {
        switch (type) {
          case 'size': {
            draft.info.sizeLimitList.push({
              fileName,
              time: dayjs(),
            });
            break;
          }
          case 'format': {
            draft.info.formatList.push({
              fileName,
              time: dayjs(),
            });
            break;
          }
          case 'error': {
            draft.info.errorList.push({
              fileName,
              desc: desc || [],
              time: dayjs(),
              file,
            });
            break;
          }
          case 'warn': {
            draft.info.warningList.push({
              fileName,
              desc: desc || [],
              time: dayjs(),
              file,
            });
            break;
          }
          default:
            break;
        }
      }),
    );
  },

  clearInfo: () => {
    set({
      info: {
        sizeLimitList: [],
        formatList: [],
        errorList: [],
        warningList: [],
      },
    });
    // set({
    //   info: {
    //     sizeLimitList: [
    //       { fileName: 'aaa', time: dayjs() },
    //       { fileName: 'bbb', time: dayjs() },
    //     ],
    //     formatList: [
    //       { fileName: 'aaa', time: dayjs() },
    //       { fileName: 'bbb', time: dayjs() },
    //     ],
    //     errorList: [
    //       { fileName: 'aaa', time: dayjs(), desc: ['err1', 'err2'] },
    //       { fileName: 'bbb', time: dayjs(), desc: ['err1', 'err2'] },
    //     ],
    //     warningList: [
    //       { fileName: 'ccc', time: dayjs(), desc: ['err1', 'err2'] },
    //       { fileName: 'ddd', time: dayjs(), desc: ['err1', 'err2'] },
    //     ],
    //   },
    // });
  },

  hasAnyError: () => {
    const list = get().info;
    const a = list.errorList.length || list.formatList.length || list.sizeLimitList.length;
    return a > 0;
  },
}));
